import React, {Fragment, useContext} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import {getCurrentLayout} from "../../appLayout";
import {
  getCurrentWizardNavItems, wizardIsDisabled
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setWizardConflictPopupOpened, setWizardSelectedValues} from "../../../actions/wizardFunctions";
import {
  updateCanvasCount, toggleSelectionFeatureInfo, addToCart, setCameFromPage, changeCartFeature,
} from "../../../actions/actionFunctions";
import MaterialsFooterBackButton from "../materialsCommon/materialsFooterBackButton";
import WithMaterialsWizardFooterCommon from "./withMaterialsWizardFooterCommon";
import {getCartItemObject} from "../../../misc/helpers";
import Analytics from "../../../analytics";
import {
  addNewQuoteWithNewRoomCartItem,
  getOtherRoomCartItemThatIsAddedToCurrentQuote,
  updateQuoteRoomsForCartItems
} from "../../../misc/categorySwitchingFunctions";
import MaterialsWizardFooterDropDown from "./materialsWizardFooterDropDown";
import {getNextNotCheckedStep, useChangeWizardStepRoute} from "./useChangeWizardStepRoute";
import MaterialsWizardFooterSelectButton from "./materialsWizardFooterSelectButton";
import {ROUTES} from "../../../routes";
import {WIZARD_GROUP_TYPES} from "../../../interfaces/wizardItemInterface";
import {renderConfirmPopup} from "../../../api/api-popups";
import {ConfirmPopupTypes} from "../../visComponents/constants";
import {shouldReplaceSelectionInfoFeature} from "../materialsCommon/materialsCommonFunctions";
import MaterialsWizardContext from "./MaterialsWizardContext";


const MaterialsWizardFooterButtons = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, setWizardSelectedValues, activePreset, history,
    selectionFeatureInfo, filterGroups, cartItems, changeCartFeature, setCameFromPage,
    selectionWindowView, toggleSelectionFeatureInfo, showAdvancedQuoting, fabricatorSettings, activeQuoteIndex,
    cartItemEditFeature, addToCart, quantityIsZero, getCurrentRelatedCartItems, qtActiveCategory, cameFromPage,
    selectionInfoQuantity, rowItems, wizardList, wizardConflictingSteps, setWizardConflictPopupOpened, isModalFixOpen,
    noteIsRequired, pulseFeatureInfoNote} = props;

  const wizContext = useContext(MaterialsWizardContext);
  const {currentGroups, wizardGroup, featureGroup} = wizContext;

  const rowIsActive = selectionWindowView === 4;

  const {changeWizardStepRoute} = useChangeWizardStepRoute();

  if (!wizardGroup) {
    return null
  }

  const goToTheNextStep = (fromSkip = false) => {
    if (!fromSkip && wizardSelectedValues[wizardActiveStep] && wizardSelectedValues[wizardActiveStep].isSkippedStep) {
      // it was skipped but now we clicked Next, delete skipped property
      setWizardSelectedValues({
        [wizardActiveStep]: {
          ...wizardSelectedValues[wizardActiveStep],
          isSkippedStep: undefined, // allow to be visible in the shopping cart and receipt
        }
      })
    }
    const realNextStep = getNextNotCheckedStep();
    changeWizardStepRoute(realNextStep);
  }

  const selectedValueIsNotFromCurrentSelections = wizardSelectedValues[wizardActiveStep] && (
    wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom
      ? (!wizardSelectedValues[wizardActiveStep].wizardGroup
        || (wizardSelectedValues[wizardActiveStep].wizardGroup.id !== wizardGroup.id && (
          !currentGroups.some(currentG => currentG.id === wizardSelectedValues[wizardActiveStep].wizardGroup.id)
        )))
      : (!wizardSelectedValues[wizardActiveStep].wizardGroup
        || (wizardSelectedValues[wizardActiveStep].wizardGroup.id !== wizardGroup.id && (!wizardGroup.mergedGroups
          || !wizardGroup.mergedGroups.some(mg => mg.id === wizardSelectedValues[wizardActiveStep].wizardGroup.id)
        )))
  );

  const onSkipClick = () => {
    setMaterialsCameFromPage();
    if (!wizardSelectedValues[wizardActiveStep] || selectedValueIsNotFromCurrentSelections) {
      // if (featureGroup && featureGroup.activeFeature
      //   && (!wizardSelectedValues[wizardActiveStep] && !Object.keys(wizardSelectedValues).some(key => {
      //     return wizardSelectedValues[key] && wizardSelectedValues[key].partId
      //       && (wizardSelectedValues[key].partId === featureGroup.partId)
      //   }))) { // disable it only in case it wasn't selected before! AS two shower fixture steps issue
      //   disableFeature(featureGroup.activeFeature);
      //   updateCanvasCount();
      // }
      setWizardSelectedValues({
        [wizardActiveStep]: {
          wizardGroup,
          isSkippedStep: true, // won't be visible in the shopping cart and receipt
        }
      });
    } else if (wizardSelectedValues[wizardActiveStep]) {
      setWizardSelectedValues({
        [wizardActiveStep]: {
          ...wizardSelectedValues[wizardActiveStep],
          isSkippedStep: true, // won't be visible in the shopping cart and receipt
        }
      })
    }
    if (selectionFeatureInfo) {
      toggleSelectionFeatureInfo(null);
    }
    goToTheNextStep(true);
  }

  // const startAgain = () => {
  //   setWizardSelectedValues({}, true);
  //   setWizardActiveStep(0);
  // }

  const setMaterialsCameFromPage = () => {
    if (cameFromPage !== "materials") {
      setCameFromPage("materials");  // no more visualizer or shoppingcart switch
    }
  }

  const nextClick = () => {
    setMaterialsCameFromPage();

    let skipBacksplash = false;
    if (wizardGroup.groupName === "Backsplash") {
      skipBacksplash = featureGroup && featureGroup.disabled;
    }
    if (!wizardSelectedValues[wizardActiveStep] || selectedValueIsNotFromCurrentSelections
      || (wizardGroup && wizardGroup.hidePriceNoCart) || skipBacksplash) {
      onSkipClick();
    } else if (!selectionFeatureInfo && wizardSelectedValues[wizardActiveStep].selectedFeature) {
      const selectedFeature = shouldReplaceSelectionInfoFeature(wizardSelectedValues[wizardActiveStep].selectedFeature);
      toggleSelectionFeatureInfo(selectedFeature);
    } else {
      if (selectionFeatureInfo) {
        toggleSelectionFeatureInfo(null);
      }
      goToTheNextStep();
    }
  }

  const executeAfterAddToCart = async () => {
    setMaterialsCameFromPage();
    const layout = getCurrentLayout();
    await layout.updateLocalStorage();
    if (selectionFeatureInfo) {
      toggleSelectionFeatureInfo(null);
    }
    if (showAdvancedQuoting) {
      history.push(ROUTES.shoppingcart);
    } else {
      goToTheNextStep();
    }
  }

  const createNewQuoteAndAddNewCartItemAfterConfirmPopupClick = async (newRoomCartItem, oldRoomCartItem) => {
    const updatedWithQuoteIndexRoomCartItem = await addNewQuoteWithNewRoomCartItem(newRoomCartItem, oldRoomCartItem);
    await addToCart([updatedWithQuoteIndexRoomCartItem]);
    await executeAfterAddToCart();
  }
  const replaceOldCartItemAfterConfirmPopupClick = async (oldCartItem, newCartItem) => {
    changeCartFeature(Object.assign({}, oldCartItem, newCartItem));
    await executeAfterAddToCart();
  }

  const updateCartAndGoBack = (analyticsLabel) => {
    Analytics.sendClickEvent(analyticsLabel);
    const layout = getCurrentLayout();
    layout.updateLocalStorage();
    history.push(ROUTES.shoppingcart);
  };

  const handleAddCartItemClick = async () => {
    if (quantityIsZero()) {
      return false;
    }
    if (noteIsRequired()) {
      return false;
    }
    if (cartItemEditFeature) {
      // changeCartItemQuantity(cartItemEditFeature, selectionInfoQuantity, true);
      const selectedFeature = selectionFeatureInfo || wizardSelectedValues[wizardActiveStep].selectedFeature
        || cartItemEditFeature.cartFeature; // we can click rows "+" and it's not selecting a selectedFeature
      let newQuantity = selectionFeatureInfo ? selectionInfoQuantity : 1;
      if (rowItems.length && selectedFeature) {
        rowItems.forEach(cItem => {
          if (cItem.cartFeature.dbFeature.id === selectedFeature.dbFeature.id) {
            newQuantity = cItem.quantity
          }
        })
      }
      changeCartFeature(Object.assign({}, cartItemEditFeature, {
        quantity: newQuantity,
        cartFeature: selectedFeature
      }));
      const arrayToAddtoTheCart = getCurrentRelatedCartItems(selectedFeature);
      const newCartItems = await updateQuoteRoomsForCartItems(arrayToAddtoTheCart, true);
      // console.log("newCartItems", newCartItems);
      if (newCartItems.length) {
        await addToCart(newCartItems);
      }
    }
    if (rowItems.length) {
      let newItems = cartItemEditFeature ? rowItems.filter(cItem => {
        const selectedFeature = selectionFeatureInfo || wizardSelectedValues[wizardActiveStep].selectedFeature
          || cartItemEditFeature.cartFeature; // we can click rows "+" and it's not selecting a selectedFeature
        return cItem.cartFeature.dbFeature.id !== selectedFeature.dbFeature.id
      }) : rowItems;
      Analytics.sendClickEvent("add-row-cart-items");
      const newCartItems = await updateQuoteRoomsForCartItems([...newItems.filter(rItem => {
        delete rItem.showRowRelatedItems; // we don't need it in the cart
        return rItem.quantity
      })], true)
      await addToCart(newCartItems);
    }
    if (cartItemEditFeature) {
      updateCartAndGoBack('update-cart-item');
      return;
    }
    if (!wizardSelectedValues[wizardActiveStep]) {
      if (selectionFeatureInfo) {
        toggleSelectionFeatureInfo(null);
      }
      onSkipClick(); // set default step value
    } else {
      const selectedFeature = selectionFeatureInfo || wizardSelectedValues[wizardActiveStep].selectedFeature;
      if ((selectedFeature && !rowIsActive) || selectionFeatureInfo) { // we already added row items above // or if it is info screen always!
        const cartItemObject = getCartItemObject(
          selectedFeature,
          selectionFeatureInfo
            ? selectionInfoQuantity || 1
            : selectedFeature && selectedFeature.dbFeature.defaultQuantity && (selectedFeature.dbFeature.defaultQuantity !== 1)
              ? selectedFeature.dbFeature.defaultQuantity
              : 1,
          qtActiveCategory
        );
        const arrayToAddtoTheCart = getCurrentRelatedCartItems(selectedFeature, [cartItemObject]);
        // const newCartItems = await updateQuoteRoomsForCartItems(arrayToAddtoTheCart, true);
        // console.log("newCartItems", newCartItems);

        const newCartItems = await updateQuoteRoomsForCartItems(arrayToAddtoTheCart, true);
        const otherRoomCartItem = getOtherRoomCartItemThatIsAddedToCurrentQuote(newCartItems);
        if (otherRoomCartItem) {
          renderConfirmPopup(ConfirmPopupTypes.ReplaceRoomWhenItExistsInCartButWeAddNew, {
            applyFunction: createNewQuoteAndAddNewCartItemAfterConfirmPopupClick.bind(this, newCartItems[0], otherRoomCartItem),
            declineFunction: replaceOldCartItemAfterConfirmPopupClick.bind(this, otherRoomCartItem, newCartItems[0]),
          });
          return // do not go below, we are waiting response from popup
        }
        await addToCart(arrayToAddtoTheCart);
      }
      await executeAfterAddToCart();
    }
  }

  const isSingleWizardGroup = currentGroups.length === 1;
  // const isSingleCustomGroup = isSingleWizardGroup && (wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom);
  const isSingleFeatureGroup = isSingleWizardGroup && (wizardGroup.nodeType === WIZARD_GROUP_TYPES.group);

  const showConflictingButton = wizardConflictingSteps?.length && fabricatorSettings.checkout && !isModalFixOpen;

  const skipVisible = wizardActiveStep > -1;

  const skipEnabled = skipVisible && !showConflictingButton && (wizardGroup.notRequired || (fabricatorSettings.checkout && cartItems.some(cartItem => {
    // cases when you go back, but you already have a cart item added
    return cartItem.currentQuote === activeQuoteIndex
        && cartItem.fromWizardGroupId === wizardGroup.id
        && cartItem.fromWizardId === wizardActiveItem.id
        && cartItem.fromWizardStep === wizardActiveStep
    // && cartItem.cartFeature
    // && cartItem.cartFeature.dbFeature
    // && cartItem.cartFeature.dbFeature.groupName === wizardGroup.groupName
  })));
  // const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  let greenNextIsVisible = !fabricatorSettings.checkout
      || (!showConflictingButton && !wizardGroup.skipProductInfo && (currentGroups.length > 1 || (!selectionFeatureInfo && !rowIsActive))); // can not be added to the cart

  let hasNavItems = true;
  let greenNextDisabled = !wizardSelectedValues[wizardActiveStep] || selectedValueIsNotFromCurrentSelections || isModalFixOpen;

  if (greenNextDisabled && isSingleFeatureGroup) {
    const navItems = getCurrentWizardNavItems(wizardSelectedValues, wizardActiveStep, wizardActiveItem, wizardGroup, featureGroup, filterGroups);
    greenNextDisabled = !!navItems.length; // if there are no nav items - let them skip the step
    hasNavItems = !!navItems.length;
    if (featureGroup && featureGroup.allFeaturesReceived && !hasNavItems) {
      greenNextIsVisible = true;
    }
  }

  const alreadyInCart = cartItemEditFeature && (selectionFeatureInfo || rowIsActive);

  const addToCartVisible = fabricatorSettings.checkout && (!showConflictingButton || isModalFixOpen)
      && !(featureGroup && featureGroup.allFeaturesReceived && !hasNavItems)
      && (wizardGroup.skipProductInfo || selectionFeatureInfo || rowIsActive) && currentGroups.length === 1; // only if it is a feature group

  const isRowViewDisabled = rowIsActive && (!rowItems.length || rowItems.every(rowItem => !rowItem.quantity));

  const isWizardStepDisabled = wizardGroup.skipProductInfo
    && (!wizardSelectedValues[wizardActiveStep] || !wizardSelectedValues[wizardActiveStep].selectedFeature);

  const isFeatureInfoDisabled = Boolean(selectionFeatureInfo && pulseFeatureInfoNote);

  const addToCartDisabled = addToCartVisible
    && (isFeatureInfoDisabled || (!selectionFeatureInfo && (isRowViewDisabled || isWizardStepDisabled)));

  return (
    <div className="selection-footer-buttons">
      {(wizardActiveStep > -1 && currentGroups.length) ? (
        <Fragment>
          {isModalFixOpen ? null : <MaterialsFooterBackButton isWizard={true}/>}
          {isModalFixOpen || selectionFeatureInfo || !Array.isArray(wizardList) || wizardList.filter(wizardItem => !wizardIsDisabled(wizardItem, activePreset)).length < 2
            ? null
            : <MaterialsWizardFooterDropDown/>}
          {showAdvancedQuoting && !showConflictingButton ? null : (
            <Fragment>
              {skipEnabled && !selectionFeatureInfo && !isModalFixOpen ? (
                <button className={"selection-footer-buttons__button selection-footer-buttons__button--next"}
                        onClick={onSkipClick}>
                  <FormattedMessage id="quotingTool.footer.skipButton"/>
                </button>
              ) : null}
              {skipEnabled && !greenNextIsVisible && selectionFeatureInfo && fabricatorSettings.checkout && !isModalFixOpen ? (
                <button className={"selection-footer-buttons__button selection-footer-buttons__button--next"}
                        onClick={nextClick}>
                  <FormattedMessage id={
                    selectionFeatureInfo ? "quotingTool.footer.skipButton" : "quotingTool.footer.nextButton"
                  }/>
                </button>
              ) : null}
              {greenNextIsVisible ? (
                <button className={"ui-button3 ui-button3--next ui-button3--next--wizard"
                  + (greenNextDisabled ? " ui-button2--gray" : " ui-button3--green pulsating--green")}
                        disabled={greenNextDisabled}
                        onClick={nextClick}>
                  <FormattedMessage id={"quotingTool.footer.nextButton"}/>
                </button>
              ) : null}
              {addToCartVisible ? (
                <button className={"selection-footer-buttons__cart ui-button2 ui-button2--cart"
                  + (addToCartDisabled ? " ui-button2--gray" : " ui-button2--green pulsating--green")}
                        disabled={addToCartDisabled || isModalFixOpen}
                        onClick={handleAddCartItemClick}>
                  <FormattedMessage id={alreadyInCart ? "quotingTool.footer.updateCartButton" : "quotingTool.footer.addToCartButton"}/>
                </button>
              ) : null}
              {showConflictingButton ? (
                <button className={"ui-button3 ui-button3--next ui-button3--next--wizard ui-button2--red"}
                        disabled={isModalFixOpen}
                        onClick={() => setWizardConflictPopupOpened(true)}>
                  <FormattedMessage id={"buttons.update"}/>
                </button>
              ) : null}
            </Fragment>
          )}
          {showAdvancedQuoting && fabricatorSettings.checkout && !showConflictingButton ? (
            <MaterialsWizardFooterSelectButton handleAddCartItemClick={handleAddCartItemClick}/>
          ) : null}
        </Fragment>
      ) : null}
    </div>
  )

};

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardConflictingSteps} = store.wizardState;
  const {selectionFeatureInfo, pulseFeatureInfoNote, selectionWindowView, selectionInfoQuantity, rowItems} = store.selectionState;
  const {cartItems, cartItemEditFeature, cameFromPage} = store.cartState;
  const {filterGroups} = store.serverState;
  const {showAdvancedQuoting} = store.advancedQuotingState;
  const {settings} = store.fabricatorState;
  const {qtActiveCategory} = store.qtState;
  const {activePreset} = store.bathroomVisualizerState;
  const {activeQuoteIndex} = store.quotesState;
  const {navigationLoadingActive} = store.navigationState; // to update disabled button when feature group navItems received
  const { isModalFixOpen } = store.sqftModalFixState;

  return {
    wizardList,
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    selectionFeatureInfo,
    filterGroups,
    cartItems, cartItemEditFeature,
    selectionWindowView,
    showAdvancedQuoting,
    fabricatorSettings: settings,
    selectionInfoQuantity,
    qtActiveCategory,
    rowItems,
    activePreset,
    cameFromPage,
    activeQuoteIndex,
    wizardConflictingSteps,
    navigationLoadingActive,
    isModalFixOpen,
    pulseFeatureInfoNote,
  };
};

const mapDispatchToProps = {
  setWizardSelectedValues,
  updateCanvasCount,
  toggleSelectionFeatureInfo,
  addToCart,
  changeCartFeature,
  setCameFromPage,
  setWizardConflictPopupOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    WithMaterialsWizardFooterCommon(MaterialsWizardFooterButtons)
  )
)
